import React from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Slider } from './ui/slider';

export const formatINR = (n) => {
  if (!isFinite(n)) return '₹0';
  return '₹' + Math.round(n).toLocaleString('en-IN');
};

export const formatINRPrecise = (n, digits = 2) => {
  if (!isFinite(n)) return '₹0';
  return '₹' + n.toLocaleString('en-IN', { minimumFractionDigits: digits, maximumFractionDigits: digits });
};

/**
 * Reusable slider + manual input field for numeric values.
 * Usage:
 * <SliderInput label="Loan Amount" unit="₹" value={amount} onChange={setAmount} min={50000} max={20000000} step={50000} formatLabel formatINR />
 */
const SliderInput = ({
  label,
  unit,
  value,
  onChange,
  min,
  max,
  step = 1,
  format,           // optional formatter for tick labels
  unitColor = 'slate',
  hint,
  inputWidth = 'w-28',
}) => {
  const tone = {
    saffron: 'bg-saffron-50 text-saffron-700',
    green: 'bg-indgreen-50 text-indgreen-700',
    slate: 'bg-slate-100 text-slate-700',
  }[unitColor] || 'bg-slate-100 text-slate-700';

  return (
    <div>
      <div className="flex items-center justify-between mb-2 gap-2">
        <Label className="text-sm font-medium text-slate-700">{label}</Label>
        <div className={`flex items-center gap-1 rounded-md px-2 py-1 ${tone}`}>
          {unit === '₹' && <span className="font-semibold text-sm">₹</span>}
          <Input
            type="number"
            step={step}
            value={value}
            onChange={(e) => {
              const v = e.target.value === '' ? '' : Number(e.target.value);
              onChange(v === '' ? min : Math.min(Math.max(v, min), max));
            }}
            className={`${inputWidth} h-7 border-0 bg-transparent p-0 text-right font-semibold focus-visible:ring-0`}
          />
          {unit && unit !== '₹' && <span className="font-semibold text-sm">{unit}</span>}
        </div>
      </div>
      <Slider min={min} max={max} step={step} value={[value]} onValueChange={(v) => onChange(v[0])} />
      <div className="flex justify-between text-[10px] text-slate-400 mt-1">
        <span>{format ? format(min) : `${min}${unit && unit !== '₹' ? unit : ''}`}</span>
        <span>{format ? format(max) : `${max}${unit && unit !== '₹' ? unit : ''}`}</span>
      </div>
      {hint && <p className="text-[11px] text-slate-400 mt-1">{hint}</p>}
    </div>
  );
};

export default SliderInput;
